import { render } from "./OpeningHoursSelect.vue?vue&type=template&id=b2700c5a&ts=true"
import script from "./OpeningHoursSelect.vue?vue&type=script&lang=ts"
export * from "./OpeningHoursSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__